// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"934":"0f2d1471","970":"a88ac9ee"}[chunkId] + ".chunk.js";
};